export default {
  filters: {
    currencyFormat(value) {
      value = parseFloat(value).toFixed(2);
      value = new Intl.NumberFormat('de-DE').format(value);
      return value;
    },
  },
};
